/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { OverlayPosition } from 'cio/utils/in-app/message-config';

interface PositionPickerArgs {
  position: OverlayPosition;
  onChange: (newPosition: OverlayPosition) => unknown;
}

const POSITIONS: {
  label: string;
  value: OverlayPosition;
  icon: string;
}[] = [
  { label: 'Top Left', value: OverlayPosition.TopLeft, icon: 'overlay-position-top-left' },
  { label: 'Top Center', value: OverlayPosition.TopCenter, icon: 'overlay-position-top' },
  { label: 'Top Right', value: OverlayPosition.TopRight, icon: 'overlay-position-top-right' },
  { label: 'Bottom Left', value: OverlayPosition.BottomLeft, icon: 'overlay-position-bottom-left' },
  { label: 'Bottom Center', value: OverlayPosition.BottomCenter, icon: 'overlay-position-bottom' },
  { label: 'Bottom Right', value: OverlayPosition.BottomRight, icon: 'overlay-position-bottom-right' },
];

export default class OverlayPositionPicker extends Component<PositionPickerArgs> {
  readonly positions = POSITIONS;
}
